module.exports = __webpack_public_path__ + "images/mdj/members/jobmail/top_img01-0a208c5840255fb4aba41ad8351a7a51.jpg";